import type { OwaDate } from "owa-datetime";
import { getTimezoneOffset, subMilliseconds } from "owa-datetime";
import isDSTTransitionDate from "./isDSTTransitionDate";

/**
 * Checks if the given time is a DST transition time.
 * A transition time is one where the timezone offset changes between
 * the specified time and 1 ms before it (e.g., when clocks spring forward or fall back).
 */
export default function isDSTTransitionTime(time: OwaDate): boolean {
    if (!isDSTTransitionDate(time)) {
        return false;
    }
    
    const currentOffset = getTimezoneOffset(time);
    const previousOffset = getTimezoneOffset(subMilliseconds(time, 1));
    
    return currentOffset !== previousOffset;
}
